"use client";
import {Tabs, TabsProps} from "antd";
import {lazy, useState} from "react";

const MyInvoice = lazy(() => import("./my-invoice"));
const InvoiceAdmin = lazy(() => import("./invoice-admin"));
const InvoiceSchedule = lazy(() => import("./invoice-schedule"));

const items: TabsProps["items"] = [
    {
        key: "1",
        label: "我的发票"
    },
    {
        key: "2",
        label: "管理发票"
    },
    {
        key: "3",
        label: "开票进度"
    }, {
        key: "4",
        label: "申请发票"
    }
];
export default function Content() {
    const [activeKey, setActiveKey] = useState("1");
    return <div>
        <Tabs activeKey={activeKey} items={items} onChange={setActiveKey}/>
        {
            activeKey === "1" ? <MyInvoice/> : activeKey === "2" ? <InvoiceAdmin/> : activeKey === "3" ?
                <InvoiceSchedule/> : null
        }
    </div>;
}
